// extracted by mini-css-extract-plugin
module.exports = {"storeIntroText":"store-intro_storeIntroText__CxCMg","introSectionWrapper":"store-intro_introSectionWrapper__eh_ys","introButton":"store-intro_introButton__p65XJ"};